import React from 'react'
import SkinCard from "./SkinCard"
import { DEFAULT } from '../../../constants/design/SkinTypes'

export default function SkinList({filter, sort, skinList, currentSkin, onSet, onChangeFilter}) {

  const displayCurrentSkin = skinList
    .filter(a => filter === 'all' || filter === a.layout || (filter == "2" && a.layout == 'etc') || (filter === 'EDITABLE_MENU' && a.isEditableMenu == '1') || (filter === 'SKIN_WIZARD' && a.wizard == '1'))
    .find(a => a.skinName === currentSkin.name)

  const displaySkinList = skinList.filter(a => {
    return a.skinName !== currentSkin.name
      && (filter === 'all' || filter === a.layout || (filter == "2" && a.layout == 'etc') || (filter === 'EDITABLE_MENU' && a.isEditableMenu == '1') || (filter === 'SKIN_WIZARD' && a.wizard == '1'))
  }).sort((a, b) => {
    if (sort === 'popular') {
      return parseInt(b.priority) - parseInt(a.priority)
    } else {
      return new Date(b.launched) - new Date(a.launched)
    }
  })

  return (
    <div className="list_skin">
      {displayCurrentSkin &&
        <SkinCard skin={displayCurrentSkin} type={DEFAULT} onSetSkin={onSet} currentSkin={currentSkin} onChangeFilter={onChangeFilter} />
      }

      {displaySkinList.map((skin, index) =>
        <SkinCard key={index} skin={skin} type={DEFAULT} onSetSkin={onSet} currentSkin={currentSkin} onChangeFilter={onChangeFilter} />
      )}
    </div>
  )
}
